import type { I18n } from '@change-corgi/core/i18n';

import type { PetitionGuidesCategoryPageData } from '#src/app/pages/petitionGuides/category/details/pageContext';

/**
 * Builds the page title, applying the `title_with_page` wrapper from page 2 onward. Shared by
 * `entryPoint/index.tsx`'s SSR `pageTitle` head method and `pageContext/provider.tsx`'s client-side
 * effect that keeps `document.title` in sync after a `?page=N` navigation.
 *
 * Takes the whole `i18n` rather than its `translate` function because `I18n.translate` is a class
 * method that reads `this._translate` — a detached reference throws once it is actually called.
 */
export function getPetitionGuidesCategoryPageTitle(
	{ seoTitle, name, page }: Pick<PetitionGuidesCategoryPageData, 'seoTitle' | 'name' | 'page'>,
	i18n: Pick<I18n, 'translate'>,
): string {
	const title = seoTitle ?? name ?? i18n.translate('corgi.petition_guides_category_page.meta.title');
	return page > 1 ? i18n.translate('corgi.petition_guides_category_page.meta.title_with_page', { title, page }) : title;
}
